// extracted by mini-css-extract-plugin
module.exports = {"container":"CardCheckbox_container__2YUZj"};